export const isEmptyObject = (obj?: Object) =>
  obj && Object.keys(obj).length === 0;
